import {
  START_LOADING,
  END_LOADING,
  FETCH_WAREHOUSES,
  FETCH_WAREHOUSE,
  CREATE_WAREHOUSE,
  UPDATE_WAREHOUSE,
  DELETE_WAREHOUSE
} from "../actions/constants";

const initialState = {
  isLoading: false,
  warehouses: [],
  currentWarehouse: null,
  numberOfPages: 0,
  currentPage: 1
};

const warehouseReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    
    case END_LOADING:
      return { ...state, isLoading: false };
    
    case FETCH_WAREHOUSES:
      return {
        ...state,
        warehouses: action.payload.warehouses,
        numberOfPages: action.payload.numberOfPages,
        currentPage: action.payload.currentPage
      };
    
    case FETCH_WAREHOUSE:
      return {
        ...state,
        currentWarehouse: action.payload
      };
    
    case CREATE_WAREHOUSE:
      return {
        ...state,
        warehouses: [...state.warehouses, action.payload]
      };
    
    case UPDATE_WAREHOUSE:
      return {
        ...state,
        warehouses: state.warehouses.map((warehouse) => 
          warehouse._id === action.payload._id ? action.payload : warehouse
        ),
        currentWarehouse: action.payload
      };
    
    case DELETE_WAREHOUSE:
      return {
        ...state,
        warehouses: state.warehouses.filter((warehouse) => warehouse._id !== action.payload),
        currentWarehouse: null
      };
    
    default:
      return state;
  }
};

export default warehouseReducer;
